import { SecurityService } from './../security/security.service';
import { AuthService } from './auth.service';
import { LoadingSpinnerService } from './../shared/services/loading-spinner.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private loader: LoadingSpinnerService,
    private securityService: SecurityService,
    private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.loaderObserv.map(() => {         
      let result = this.authService.isAuthenticated();
      if(!result && !this.authService.isPasswordResetRequired()){
        if(this.authService.tokeExists())
          this.securityService.logout();
        this.router.navigate(['/security/login'])
      }
      else if(result && this.authService.isPasswordResetRequired() && state.url !== '/security/change-password'){
        this.router.navigate(['/security/change-password'])
        this.securityService.toastr.warning('You need to change password before start application');
      }
      else if(result && !this.securityService.currentUserInfo.documentRequested && state.url === '/additional-resources'){
        this.router.navigate(['/stages'])
        this.securityService.toastr.error('Cannot access Additional Resources until applicant has been Invited');
      }
                     
      return result;
    });
  }

  private loaderObserv = new Observable<boolean>(observer => {
    this.loader.showSpinner();  

      setTimeout(() => {
        observer.next();
        observer.complete();
      });
    
  });
}


// WEBPACK FOOTER //
// ./src/app/auth/auth.guard.ts